/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Filters_AllInputs */

const id_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const ms_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const da_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const de_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const en_us2_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_es2_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const es_mx2_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const fil_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat`)
};

const fr_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const it_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti`)
};

const hu_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mind`)
};

const nl_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const no_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const pl_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie`)
};

const pt_br2_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const pt_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const ro_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate`)
};

const fi_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki`)
};

const sv_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla`)
};

const vi_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

const tr_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümü`)
};

const cs_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vše`)
};

const bg_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички`)
};

const ru_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const uk_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі`)
};

const ar_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل`)
};

const hi_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const th_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทั้งหมด`)
};

const ja_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

const zh_cn2_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const zh_hant1_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ko_profile_library_filters_all = /** @type {(inputs: Profile_Library_Filters_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Profile_Library_Filters_AllInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_filters_all = /** @type {((inputs?: Profile_Library_Filters_AllInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Filters_AllInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_filters_all(inputs)
	if (locale === "ms") return ms_profile_library_filters_all(inputs)
	if (locale === "da") return da_profile_library_filters_all(inputs)
	if (locale === "de") return de_profile_library_filters_all(inputs)
	if (locale === "en-US") return en_us2_profile_library_filters_all(inputs)
	if (locale === "es-ES") return es_es2_profile_library_filters_all(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_filters_all(inputs)
	if (locale === "fil") return fil_profile_library_filters_all(inputs)
	if (locale === "fr") return fr_profile_library_filters_all(inputs)
	if (locale === "it") return it_profile_library_filters_all(inputs)
	if (locale === "hu") return hu_profile_library_filters_all(inputs)
	if (locale === "nl") return nl_profile_library_filters_all(inputs)
	if (locale === "no") return no_profile_library_filters_all(inputs)
	if (locale === "pl") return pl_profile_library_filters_all(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_filters_all(inputs)
	if (locale === "pt") return pt_profile_library_filters_all(inputs)
	if (locale === "ro") return ro_profile_library_filters_all(inputs)
	if (locale === "fi") return fi_profile_library_filters_all(inputs)
	if (locale === "sv") return sv_profile_library_filters_all(inputs)
	if (locale === "vi") return vi_profile_library_filters_all(inputs)
	if (locale === "tr") return tr_profile_library_filters_all(inputs)
	if (locale === "cs") return cs_profile_library_filters_all(inputs)
	if (locale === "bg") return bg_profile_library_filters_all(inputs)
	if (locale === "ru") return ru_profile_library_filters_all(inputs)
	if (locale === "uk") return uk_profile_library_filters_all(inputs)
	if (locale === "ar") return ar_profile_library_filters_all(inputs)
	if (locale === "hi") return hi_profile_library_filters_all(inputs)
	if (locale === "th") return th_profile_library_filters_all(inputs)
	if (locale === "ja") return ja_profile_library_filters_all(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_filters_all(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_filters_all(inputs)
	return ko_profile_library_filters_all(inputs)
});
export { profile_library_filters_all as "profile.library.filters.all" }